export default __webpack_public_path__ + "static/media/Gym1.46247ee6.jpg";